const socialData = [
	{
		platform: "linkedin",
		link: "https://www.linkedin.com/in/alvin-agidi-637b7b20a/",
		icon: "fab fa-linkedin socialIcon",
		color: "#2867B2",
	},
	{
		platform: "github",
		link: "https://github.com/alvin-agidi",
		icon: "fab fa-github-square socialIcon",
		color: "#6e5494",
	},
	{
		platform: "email",
		link: "mailto:alvin.agidi@gmail.com",
		icon: "fas fa-envelope-square socialIcon",
		color: "#B23121",
	},
];

export default socialData;
